import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import LanguageRouter from './components/LanguageRouter';
import PrivacyBanner from './components/PrivacyBanner';
import Home from './pages/Home';
import Offices from './pages/Offices';
import Residential from './pages/Residential';
import Warehouses from './pages/Warehouses';
import Hotels from './pages/Hotels';
import Campuses from './pages/Campuses';
import Hospitals from './pages/Hospitals';
import Gyms from './pages/Gyms';
import RequestPlacement from './pages/RequestPlacement';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import Security from './pages/Security';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <LanguageRouter>
          <Routes>
            {/* Redirect root to default language */}
            <Route path="/" element={<Home />} />
            
            {/* Language-prefixed routes */}
            <Route path="/:lang" element={<Home />} />
            <Route path="/:lang/offices" element={<Offices />} />
            <Route path="/:lang/residential" element={<Residential />} />
            <Route path="/:lang/warehouses" element={<Warehouses />} />
            <Route path="/:lang/hotels" element={<Hotels />} />
            <Route path="/:lang/campuses" element={<Campuses />} />
            <Route path="/:lang/hospitals" element={<Hospitals />} />
            <Route path="/:lang/gyms" element={<Gyms />} />
            <Route path="/:lang/request-placement" element={<RequestPlacement />} />
            <Route path="/:lang/contact" element={<Contact />} />
            <Route path="/:lang/privacy" element={<Privacy />} />
            <Route path="/:lang/terms" element={<Terms />} />
            <Route path="/:lang/cookies" element={<Cookies />} />
            <Route path="/:lang/security" element={<Security />} />
            
            {/* Security page without language prefix */}
            <Route path="/security" element={<Security />} />
          </Routes>
          {/* Privacy Banner - appears on all pages */}
          <PrivacyBanner />
        </LanguageRouter>
      </Router>
    </HelmetProvider>
  );
}

export default App;
